import { IMAGE_FETCH_SUCCESS, IMAGE_FETCH_FAIL } from '../constant/actionType';

export const initialState = {
  images: [],
  isFailed: false,
  isLoaded: false
};

const imageReducer = (state = initialState, action) => {
  switch (action.type) {
    case IMAGE_FETCH_SUCCESS: {
      const { files: images } = action.data;

      return { ...state, images, isFailed: false, isLoaded: true };
    }

    case IMAGE_FETCH_FAIL: {
      return { ...state, isFaled: true, isLoaded: true };
    }

    default:
      return state;
  }
};

export default imageReducer;
